import angular from 'angular';
import Rx from 'rx';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import {getDateRanges, normalizeTimeframe} from '../../common/datetime/date-ranges';
import {topCountriesTransformResponse} from '../../common/util/chart-util';
import template from './segmentsEngagementShow.jade';
import segmentsEditModalTemplate from './segmentsEditModal.jade';

export class SegmentsEngagementShowController {
  /* @ngInject */
  constructor($stateParams,$localStorage,$filter,currentGame,SegmentsResource,SegmentAnalyticsResource,SegmentAnalyticsBreakdownResource,SegmentSizePreviewResource,SegmentTlMatchedUsersSizePreviewResource,SegmentMatchingSegmentSizePreviewResource,GamesResource,ModalService,ggTable) {
    this.$stateParams = $stateParams;
    this.$localStorage = $localStorage;
    this.translate = $filter('translate');
    this.apiDate = $filter('apiDate');
    this.currentGame = currentGame;
    this.SegmentsResource = SegmentsResource;
    this.SegmentAnalyticsResource = SegmentAnalyticsResource;
    this.SegmentAnalyticsBreakdownResource = SegmentAnalyticsBreakdownResource;
    this.SegmentSizePreviewResource = SegmentSizePreviewResource;
    this.SegmentTlMatchedUsersSizePreviewResource = SegmentTlMatchedUsersSizePreviewResource;
    this.SegmentMatchingSegmentSizePreviewResource = SegmentMatchingSegmentSizePreviewResource;
    this.GamesResource = GamesResource;
    this.ModalService = ModalService;
    this.query = new Rx.Subject();

    this.timeframe = normalizeTimeframe(this.$localStorage.timeframe);
    this.timeframeForPreview = {
      startDate: getDateRanges().yesterday[0],
      endDate: getDateRanges().today[1]
    };

    this.series = {
      size: [
        {
          metric: 'joining',
          type: 'column',
          format: 'number',
          customYAxesIndex: 0
        },
        {
          metric: 'leaving',
          type: 'column',
          format: 'number',
          customYAxesIndex: 0
        },
        {
          metric: 'size',
          primary: true,
          type: 'spline',
          format: 'number',
          customYAxesIndex: 1
        }
      ],
      payments: [
        {
          metric: 'paying_users',
          primary: true,
          type: 'spline',
          format: 'number'
        },
        {
          metric: 'payments',
          type: 'spline',
          format: 'number'
        },
        {
          metric: 'revenue',
          type: 'spline',
          format: (() => this.currency),
          yAxis: 1,
          serieCopy: {
            bigLabel: 'lastRowValue'
          }
        }
      ],
      topAcquisitionSources: [
        {
          type: 'spline',
          format: 'number',
          queryParams: {breakdown_dimension: 'top_acquisition_sources', top_n: 20}
        }
      ],
      topCountries: [
        {
          type: 'spline',
          format: 'number',
          queryParams: {breakdown_dimension: 'top_countries', top_n: 20},
          transformResponse: ((res) => topCountriesTransformResponse(res, this.translate))
        }
      ],
      knownIds: [
        {
          type: 'spline',
          format: 'number',
          queryParams: {breakdown_dimension: 'known_ids', top_n: 20}
        }
      ],
      topPlatforms: [
        {
          type: 'spline',
          format: 'number',
          queryParams: {breakdown_dimension: 'top_platforms', top_n: 20}
        }
      ]
    };

    this.getSegmentAnalytics();

    this.campaignsTable = new ggTable({
      sorting: {
        status: 'asc'
      }
    });
  }

  getSegmentAnalytics() {
    this.getSegment(this.$stateParams.id);
  }

  getSegmentTlMatchedUsersSize(id) {
    this.SegmentTlMatchedUsersSizePreviewResource.one().get({segment_id: parseInt(id)})
        .then((preview) => {
          this.tlMatchedUsers = preview.tl_matched_users_size;
          this.segmentTlMatchedUsersLoaded = true;
        });
  }

  getSegmentSize(id) {
    this.SegmentSizePreviewResource.post({game_id: this.$stateParams.gameId, segment_id: id, definition: this.segment.definition})
    .then((preview) => {
      this.segmentSize = preview.segment_size;
      this.segmentSizeLoaded = true;
    });
  }

  getSegmentMatchingSegmentSizePreviewResource(id) {
    this.SegmentMatchingSegmentSizePreviewResource.post({game_id: this.$stateParams.gameId, segment_id: id})
    .then((preview) => {
      this.matchingSegmentSize = preview.matching_segment_size;
      this.matchingSegmentSizeLoaded = true;
    });
  }

  getSegment(id){
    this.SegmentsResource.one(id).get().then(segment => {
      this.segment = segment;

      return this.getCurrency()
        .then(() => this.updateSegmentAnalyticsQuery());
    });
  }

  getCurrency() {
    return this.GamesResource.one(this.$stateParams.gameId).get()
      .then((game) => game.getGameDeveloper())
      .then((gameDeveloper) => this.currency = gameDeveloper.currency);
  }

  updateSegmentAnalyticsQuery(){
    this.$localStorage.timeframe = this.timeframe;

    if (!this.segment) {
      return;
    }

    this.query.onNext({
      segment_id: this.segment.id,
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate)
    });

    this.getSegmentSize(this.$stateParams.id);
    this.getSegmentTlMatchedUsersSize(this.$stateParams.id);
    this.getSegmentMatchingSegmentSizePreviewResource(this.$stateParams.id);
  }

  showEditSegmentModal() {
    this.ModalService.showModal({
      template: segmentsEditModalTemplate(),
      controllerAs: 'vm',
      controller: 'EditSegmentModalController',
      inputs: {
        segment: this.segment,
        enablePreviews: false
      }
    });
  }
}

export function SegmentsEngagementShowComponent() {
  return {
    template,
    controller: SegmentsEngagementShowController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.segments.showEngagement', [
  'angularModalService',
  ServicesModule.name,
  ResourcesModule.name
])
  .directive('segmentsEngagementShow', SegmentsEngagementShowComponent);



/** WEBPACK FOOTER **
 ** ./src/components/segments/segmentsEngagementShow.js
 **/